"use client";
import { DatePicker, TimePickerProps } from "@basic-components";
import dayjs from "dayjs";

interface MultipleTimePickerProps
  extends Omit<TimePickerProps, "value" | "onChange" | "defaultValue"> {
  value?: Array<string> | string;
  onChange?: (range: Array<string> | string) => void;
  valueType?: "string" | "array" | 'long';
  splitChar?: string;
  onOk?: (dates: any) => void;
}

export function MultipleTimePicker({
  value,
  onChange,
  valueType = "string",
  format = "HH:mm",
  maxTagCount = "responsive",
  splitChar = ",",
  onOk,
  ...rest
}: MultipleTimePickerProps) {
  const dates = Array.isArray(value) ? value : value?.split(splitChar) || [];
  const formattedDates = dates
    .filter((date: string) => date)
    .map((date: string) => dayjs(date, format as string));

  const handleChange = (dates: any) => {
    const arrayTime = dates.map((date: dayjs.Dayjs) =>
      date.format(format as string)
    );

    if (arrayTime.length === 2) {
      onChange?.(valueType === "array" ? arrayTime : arrayTime.join(splitChar));
      onOk?.(valueType === "array" ? arrayTime : arrayTime.join(splitChar));
    }

  };
  return (
    <DatePicker
      {...rest as any}
      value={formattedDates}
      multiple
      format={format}
      onChange={handleChange}
      picker="time"
      maxTagCount={maxTagCount}
      onOk={handleChange}
    />
  );
}
